import { TemplateDto } from "../../dto/template";
import { ActionType } from "../action-types";
import { Action } from "../actions";

export type TemplatesState = TemplateDto[];

const initialState: TemplatesState = [];

export const templatesReducer = (
  state: TemplatesState = initialState,
  action: Action
) => {
  switch (action.type) {
    case ActionType.SET_TEMPLATES:
      const payload = action.payload;
      return Array.isArray(payload) ? payload : payload["templates"];
    default:
      return state;
  }
};
